import { render, staticRenderFns } from "./FileUpload.vue?vue&type=template&id=11c37a38&scoped=true"
import script from "./FileUpload.vue?vue&type=script&setup=true&lang=ts"
export * from "./FileUpload.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11c37a38",
  null
  
)

export default component.exports